export default __webpack_public_path__ + "static/select-replay-control-flag-f661d2b66f24de67c08361aa7db571d6.png";